import useRect from 'hooks/common/useRect';
import React from 'react';
import T from 'utils/T';
import ex from 'utils/ex';

import * as Luxon from 'luxon';
import VBox from 'components/common/VBox';
import Search from 'components/common/Search';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';


import WheelScroll from 'components/common/WheelScroll';
import HBox from 'components/common/HBox';
import FocusableButton from 'components/common/FocusableButton';
import focusElement from 'utils/focusElement';
import hotkey from 'utils/hotkey';
import useLayoutRect from 'hooks/common/useLayoutRect';
import useForceUpdate from 'hooks/common/useForceUpdate';
import Check from 'components/common/Check';

export default function Download(props) {
  const {
    id,
    reference, // Element
    placement,
    connection, // 'start-arrow' (default) | 'line' | 'end-arrow' | 'arrow' | 'none'
    width, // integer | 'auto'
    height, // integer | 'auto'
    veilable, // Boolean
    stickable, // Boolean
    movable, // Boolean
    closable, // Boolean
    escapable, // Boolean
    modal, // Boolean
    dim, // color (default=transparent)
    tags = [],
    type,
    title,
    description,
    contents,
    buttons = [],
    events = {},
    props: {
      renderer,
      items = [],
      values = {},
      disabled = {},
    },
    close,
    ...rest
  } = props || {};

  const today = React.useMemo(() => Luxon.DateTime.now(), []);

  const ref = React.useRef();
  const searchRef = React.useRef();
  const rect = useLayoutRect(reference);
  const floatingRect = useRect(ref);

  React.useEffect(() => {
    const cancel = hotkey(['Escape']);
    const onKeyDown = (e) => {
      cancel(e, () => {
        e.preventDefault();
        e.stopPropagation();
        return events?.onClose();
      });
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events?.onClose]);

  const style = React.useMemo(() => {
    const info = {};
    if (!(width && width === 'auto')) {
      info.width = width;
    }
    if (!(height && height === 'auto')) {
      info.height = height;
    }
    switch (placement) {
      case 'top-left': {
        break;
      }
      case 'top': {
        break;
      }
      case 'top-right': {
        break;
      }
      case 'bottom-left': {
        const top = rect.top + rect.height;
        info.top = top;
        info.left = rect.left;
        info.minWidth = rect.width;
        break;
      }
      case 'bottom': {
        break;
      }
      case 'bottom-right': {
        const top = rect.top + rect.height;
        const right = window.innerWidth - (rect.left + rect.width);
        info.top = top;
        info.right = right;
        break;
      }
      case 'left-top': {
        break;
      }
      case 'left': {
        break;
      }
      case 'left-bottom': {
        break;
      }
      case 'right-top': {
        break;
      }
      case 'right': {
        break;
      }
      case 'right-bottom': {
        break;
      }
      default: {
        break;
      }
    }
    return info;
  }, [placement, rect.height, rect.left, rect.top, rect.width, floatingRect.top, floatingRect.left]);

  const forceUpdate = useForceUpdate();
  React.useEffect(() => {
    requestAnimationFrame(() => {
      const tabElements = [...document.querySelectorAll('[data-select-id][tabIndex]')];
      tabElements[0]?.focus();
      // 포커스가 변하면서 기존 reference의 위치가 변할 경우를 위해 한번 더 렌더링
      requestAnimationFrame(() => {
        forceUpdate();
      });
    });
  }, [forceUpdate, items]);

  const onButtonKeyDown = React.useCallback((e) => {
    switch (e.key) {
      case 'Shift':
      case 'ArrowDown':
      case 'ArrowUp':
      case 'Tab':
        return;
      case ' ':
        e.preventDefault();
        e.stopPropagation();
        break;
      default:
        console.log(e.key);
        requestAnimationFrame(() => {
          searchRef.current?.focus();
        });
        break;
    }
  }, []);
  return (
    <div
      {...ex('Dim')}
      {...{ onClick: events?.onOuterClick(ref) }}
    >
      <VBox
        {...ex(['Floating', 'DownloadDropdown', ...tags], rest)}
        {...{
          ref,
          style,
        }}
      >
        {items.map((item, index) => {
          return (
            <Check
              key={index}
              {...ex('DownloadItem')}
              {...{
                disabled: disabled[item.key],
                checked: values[item.key],
                onClick: events?.onCheck(item),
                onKeyDown: onButtonKeyDown,
                'data-select-id': id,
                'data-index': item?.index,
                'data-row-index': index,
              }}
            >
              {renderer(item)}
            </Check>
          )
        })}
      </VBox>
    </div>
  );
}
